export const ListActionsMouvement = [
    "Vente","Reception","Transfert","Inventaire","Reservation","Achat",'Avoir','Correction','BonSortie'
]
export const optionsActionsMouvement = ListActionsMouvement.map(action => ({
    value: action,
    label: action
  }));
